<template>
  <div>
    <vs-popup :title="popupTitle" fullscreen :active.sync="popupActive">
      <iframe :src="url" style="width:100%; height: 100%"></iframe>
    </vs-popup>
    <div class="vx-row">
      <div class="vx-col  xl:w-1/2  w-full mb-base">
        <vx-card title="Documenten">
          <vs-table
            :data="documents"
            pagination
            max-items="10"
            noDataText="Geen documenten"
          >
            <template slot="thead">
              <vs-th></vs-th>

              <vs-th>Datum</vs-th>
              <vs-th>Document</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].id">
                  <div class="vx-row">
                    <div class="vx-col px-1">
                      <vs-button
                        color="success"
                        type="border"
                        icon-pack="feather"
                        icon="icon-download"
                        :href="getDocument(data[indextr].id)"
                      ></vs-button>
                    </div>
                  </div>
                </vs-td>
                <vs-td :data="data[indextr].date">
                  {{ data[indextr].date | date }}
                </vs-td>
                <vs-td :data="data[indextr].document_type">
                  {{ data[indextr].document_type }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import moment from "moment";
export default {
  data() {
    return {
      documents: [],
      popupActive: false,
      url: null,
      innerHeight: 0,
      popupTitle: null
    };
  },
  methods: {
    async getDocuments() {
      let res = await axios().get("api/Documents");
      this.documents = res.data;
    },

    // async showDocument(id) {
    //   let doc = this.documents.find(d => d.id == id);
    //   this.popupTitle = `${doc.document_type} ${moment(doc.date)
    //     .locale("nl")
    //     .format("LL")}`;

    //   console.log(doc);
    //   const [fileURL, filename] = await this.getDocument(id);
    //   this.url = fileURL + `?saveName=${filename}`;

    //   this.popupActive = true;
    // },
    getDocument(id) {
      return process.env.VUE_APP_API_BASE_URL + `/api/Documents/${id}`;
    }
  },

  filters: {
    date: function(date) {
      return moment(date)
        .locale("nl")
        .format("LL");
    }
  },
  async created() {
    await this.getDocuments();
  }
};
</script>

<style>
iframe {
  height: 100%;
  border: 0;
}
.vs-popup--content {
  height: 100%;
}
</style>
